// All static phrases of UI should be present here as English - Us Language
// in future we can have files in other languages too
// please don't use textTransform properties on these phrases and Have the text as exactly it needs to be rendered.
const currentYear = new Date().getFullYear();
export const CONTACT_EMAIL = 'contact@vesis.in';
export const content = {
    about: {
        header: 'How We Work',
        pageHeading:
            'Vesis is all about transformation. As technology reshapes our world, we adapt and grow. We empower our clients to do the same.',
        subHeader:
            'Vesis is built on a foundation of collaboration, seamlessly blending creativity and technological expertise to drive innovation at the intersection of diverse fields. Inclusion powers our creativity. We believe that a space where people from varied backgrounds can come together to share their perspectives makes us stronger and more imaginative as a team. At Vesis, we embrace flexibility and adaptability, bringing together the best talent from  across our network, wherever they may be, to deliver exceptional solutions for our clients.',
    },
    aboutPage: {
        header: 'Registered Office',
        subHeader: '27/2 Athpur, N. 24 Parganas, West Bengal-743128',
    },
    commingSoon: {
        message: 'This feature is being built. Please check back later for updates.',
    },
    common: {
        ariaLables: {
            filter: 'filter',
        },
        text: {
            comingSoon: 'Coming Soon',
            filterBy: 'Filter By',
        },
    },
    contactUs: {
        heading: "Let's create something extraordinary",
        message: "Got something in mind? We'd love to help.",
    },
    contactUsModal: {
        companyName: 'VESIS SOLUTIONS (OPC) Pvt. Ltd.',
        contactDetails: [
            {
                email: CONTACT_EMAIL,
                phoneOne: '+91 7003595298',
                phoneTwo: '+91 8617584488',
            },
        ],
        subHeadings: {
            address: 'Address',
            contactDetails: 'Contact Details',
            contactUs: 'Contact Us',
        },
    },
    expertise: {
        header: 'Our Expertise',
        subHeader:
            'We combine the right skills with cutting-edge technology to create experiences that influence how people connect with brands throughout their entire ecosystem.',
        subtitle: ' Discover how we can assist you.',
    },
    featuredWork: {
        header: 'Featured Work',
        subHeader:
            'Explore our portfolio of exceptional projects that showcase our dedication, skill, and commitment to our craft',
    },
    feedback: {
        pageHeading: 'What our clients say about us',
    },
    footer: {
        headings: {
            company: 'Company',
            legal: 'Legal',
            products: 'Products',
            support: 'Support',
        },
        subHeadings: {
            aboutUs: 'About us',
            blog: 'Blog',
            careers: 'Careers',
            community: 'Community',
            compliance: 'Compliance',
            contactUs: 'Contact us',
            demo: 'Demo',
            features: 'Features',
            help: 'Help Center',
            integrations: 'Integrations',
            press: 'Press',
            pricing: 'Pricing',
            privacy: 'Privacy Policy',
            security: 'Security',
            terms: 'Terms of Service',
        },
        waterMarkContent: {
            content: `© ${currentYear} Vesis Solutions (OPC) Pvt. Ltd. All rights reserved`,
        },
    },
    homePage: {
        homePageTitle: 'Empower Your Vision with Tailored Digital Solutions',
    },
    navbar: {
        menu: {
            careers: 'Careers',
            company: 'Company',
            expertise: 'Expertise',
            home: 'Home',
            products: 'Products',
            support: 'Support',
        },
    },
    privacyPolicy: {
        header: 'Privacy Policy',
        lastUpdated: 'Last Updated',
    },
};
